export default {"src":"/_next/static/media/jee-mains.f28cac1f.svg","height":54,"width":54};